<template>
  <div id="sidebar">
    <div class="header">
      <h2 class="logo">
        บ้านรู้ใจ
      </h2>
      <p class="env-name">
        <b>{{ envName }}</b>
      </p>
      <div class="media">
        <div class="media-body">
          <p>
            <b>{{ firstName }} {{ lastName }}</b>
          </p>
        </div>
        <div
          class="
            mx-3 pointer
          "
          @click="
            showLogout = true
          ">
          <img
            src="/static/icons/iconlogoutblack.svg"
          />
        </div>
      </div>
    </div>
    <ul
      class="sidebar-nav"
      @mouseover="
        showSidebar(true)
      "
      @mouseleave="
        showSidebar(false)
      ">
      <li
        v-for="
          item in menu
        "
        :key="
          item.title
        "
        v-show="
          item.canView
        ">
        <label>
          {{ item.title }}
        </label>
        <ul>
          <router-link
            v-for="(route, i) in item.menu"
            :key="i"
            :to="
              route.to
            "
            tag="li"
            class="
              sidebar-detail pointer
            "
            active-class="active"
            :class="
              route.klass
            "
            v-show="
              typeof route.canView === 'undefined' ? true : route.canView
            ">
            <div
              class="
                sidebar-item
              "
              @click="
                handleOpenNewTab(route.to)
              ">
              <div class="icon">
                 <i
                  v-if="
                    route.iconClass
                  "
                  :class="
                    route.iconClass
                  "
                />
                <img
                  v-else-if="route.icon" :src="route.icon"
                />
              </div>
              <p class="item-name">
                {{ route.label }}
              </p>
            </div>
          </router-link>
        </ul>
      </li>
    </ul>
    <div class="version">
      <small>
        {{ $t("version") }} {{ version }}
      </small>
    </div>
    <confirm
      v-show="
        showLogout
      "
      @confirm="
        logout
      "
      :data="
        logoutDialog
      ">
    </confirm>
  </div>
</template>

<script>
import axios from "axios";
import { version } from "@/../package.json";
import { SIDE_NAV_BAR_FEATURE } from "@/config/enums";
import { backendAdminClient } from "@/dependencies";
import { baanRueJaiClient } from "@/dependencies";
import { permissionRole } from "@/lib/mapper";
import { getCookie, Auth, unsetCookie } from "@/lib/cookie";

export default {
  data() {
    return {
      showLogout: false,
      firstName: localStorage.getItem("adminFirstName"),
      lastName: localStorage.getItem("adminLastName"),
      permission:
        JSON.parse(localStorage.getItem("adminRolePermission")) || null,
      logoutDialog: {
        title: "คุณต้องการออกจากระบบ",
        buttonCancel: "ยกเลิก",
        buttonSubmit: "ตกลง"
      },
      version,
      greetings: [],
      contactBadge: false
    };
  },
  computed: {
    menu() {
      const articleMenu = {
        title: this.$t("feature.staff.access.news.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.NEWS,
          SIDE_NAV_BAR_FEATURE.ACTIVITY,
          SIDE_NAV_BAR_FEATURE.PRIVILEGE,
          SIDE_NAV_BAR_FEATURE.BANNER,
          SIDE_NAV_BAR_FEATURE.PINNED_ARTICLE,
          SIDE_NAV_BAR_FEATURE.NOTICE,
          SIDE_NAV_BAR_FEATURE.POPUP_BANNER
        ]),
        menu: [
          {
            to: this.articleRoute("news"),
            label: this.$t("feature.staff.access.news.news"),
            icon: "/static/icons/sidebar-icon-news.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.NEWS])
          },
          {
            to: this.articleRoute("activities"),
            label: this.$t("feature.staff.access.news.activity"),
            icon: "/static/icons/sidebar-icon-activity.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.ACTIVITY])
          },
          {
            to: this.articleRoute("privileges"),
            label: this.$t("feature.staff.access.news.privilege"),
            icon: "/static/icons/sidebar-icon-privilege.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.PRIVILEGE])
          },
          {
            to: { name: "BannerList", params: { articleType: "banner" } },
            label: this.$t("feature.staff.access.news.banner"),
            icon: "/static/icons/sidebar-icon-banner.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.BANNER])
          },
          {
            to: { name: "ArticlePinnedPage" },
            label: this.$t("feature.staff.access.news.pinned_article"),
            icon: "/static/icons/sidebar-icon-news.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.PINNED_ARTICLE])
          },
          {
            to: { name: "NoticeListPage" },
            label: this.$t("feature.staff.access.news.notice"),
            icon: "/static/icons/sidebar-icon-banner.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.NOTICE])
          },
          {
            to: { name: "PopupBannerListPage" },
            label: this.$t("feature.staff.access.news.popup_banner"),
            icon: "/static/icons/sidebar-icon-banner.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.POPUP_BANNER])
          }
        ]
      };

      const managementMenu = {
        title: this.$t("feature.staff.access.service.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.QR_CHECK_IN,
          SIDE_NAV_BAR_FEATURE.USER_LIST,
          SIDE_NAV_BAR_FEATURE.PROJECT_LIST,
          SIDE_NAV_BAR_FEATURE.CONTACT_PROJECT,
          SIDE_NAV_BAR_FEATURE.HOME_CARE,
          SIDE_NAV_BAR_FEATURE.RESIDENT_LIST,
          SIDE_NAV_BAR_FEATURE.STAFF_MANAGEMENT,
          SIDE_NAV_BAR_FEATURE.GREETING,
          SIDE_NAV_BAR_FEATURE.REPORT,
          SIDE_NAV_BAR_FEATURE.MESSAGING,
          SIDE_NAV_BAR_FEATURE.STAFF_LINE_MANAGEMENT,
          SIDE_NAV_BAR_FEATURE.YOU_TELL_US
        ]),
        menu: [
          {
            to: { name: "QRCheckin" },
            icon: "/static/icons/sidebar-icon-member-management.svg",
            label: this.$t("feature.staff.access.service.qr_check_in"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.QR_CHECK_IN])
          },
          {
            to: { name: "UserListPage" },
            icon: "/static/icons/sidebar-icon-member-management.svg",
            label: this.$t("feature.staff.access.service.user_list"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.USER_LIST])
          },
          {
            to: { name: "ProjectListPage" },
            icon: "/static/icons/sidebar-icon-member-management.svg",
            label: this.$t("feature.staff.access.service.project_list"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.PROJECT_LIST])
          },
          {
            to: { name: "ContactProject" },
            icon: "/static/icons/sidebar-icon-conversation.svg",
            label: this.$t("feature.staff.access.service.contact_project"),
            klass: { notification: this.contactBadge > 0 },
            canView: this.canView([SIDE_NAV_BAR_FEATURE.CONTACT_PROJECT])
          },
          {
            to: { name: "HomecareProject" },
            icon: "/static/icons/sidebar-icon-homecare.svg",
            label: this.$t("feature.staff.access.service.home_care"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.HOME_CARE])
          },
          {
            to: { name: "ResidentByProjectListPage" },
            icon: "/static/icons/sidebar-icon-member-management.svg",
            label: this.$t("feature.staff.access.service.resident_list"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.RESIDENT_LIST])
          },
          {
            to: { name: "Staffs" },
            icon: "/static/icons/sidebar-icon-staff-management.svg",
              label: this.$t("feature.staff.access.service.staff_management"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.STAFF_MANAGEMENT])
          },
          {
            to: { name: "Greeting" },
            icon: "/static/icons/sidebar-icon-greeting.svg",
            label: this.$t("feature.staff.access.service.greeting"),
            klass: { notification: this.greetings.length > 0 },
            canView: this.canView([SIDE_NAV_BAR_FEATURE.GREETING])
          },
          {
            to: { name: "Report" },
            icon: "/static/icons/sidebar-icon-report.svg",
            label: this.$t("feature.staff.access.service.report"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.REPORT])
          },
          {
            to: { name: "Messaging" },
            icon: "/static/icons/sidebar-icon-greeting.svg",
            label: this.$t("feature.staff.access.service.messaging"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.MESSAGING])
          },
          {
            to: { name: "LineNotify" },
            icon: "/static/icons/sidebar-icon-staff-management.svg",
            label: this.$t("feature.staff.access.service.staff_line_management"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.STAFF_LINE_MANAGEMENT])
          },
          {
            to: { name: "FeedbackReportPage" },
            icon: "/static/icons/sidebar-icon-report.svg",
            label: this.$t("feature.staff.access.service.you_tell_us"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.YOU_TELL_US])
          }
        ]
      };

      const EvMenu = {
        title: "EV Parking",
        canView: this.canView([SIDE_NAV_BAR_FEATURE.EV_PARKING]),
        menu: [
          {
            to: { name: "EvOverviewPage" },
            icon: "/static/icons/sidebar-icon-report.svg",
            label: this.$t("feature.staff.access.ev_parking.ev_parking"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.EV_PARKING])
          }
        ]
      };

      const subscriptionMenu = {
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_MEMBER,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_COLLECTION,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_PACKAGE,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_SERVICE,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_SERVICE_CATEGORY,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_SERVICE_PROVIDER,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_RECEIPT,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_COUPON,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_REQUESTED_PACKAGE,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_REPORT,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_ACCOUNTING_REPORT,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_APPOINTMENT,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_PRODUCT_APPOINTMENT,
          SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_APPOINTMENT_RATING,
          SIDE_NAV_BAR_FEATURE.LEAD_GENERATOR,
          SIDE_NAV_BAR_FEATURE.LEAD_GENERATOR_CC
        ]),
        title: this.$t("feature.staff.access.subscription.group_name"),
        menu: [
          {
            to: { name: "SubscriberListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_member"),
            icon: "/static/icons/sidebar-icon-subscriber.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_MEMBER])
          },
          {
            to: { name: "CollectionListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_collection"),
            icon: "/static/icons/sidebar-icon-collection.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_COLLECTION
            ])
          },
          {
            to: { name: "PackageListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_package"),
            icon: "/static/icons/sidebar-icon-package.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_PACKAGE])
          },
          {
            to: { name: "ServiceListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_service"),
            icon: "/static/icons/sidebar-icon-service.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_SERVICE])
          },
          {
            to: { name: "ServiceCategoryListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_service_category"),
            icon: "/static/icons/sidebar-icon-service.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_SERVICE_CATEGORY
            ])
          },
          {
            to: { name: "LeadManagementPage" },
            label: this.$t("feature.staff.access.subscription.lead_generator"),
            icon: "/static/icons/sidebar-icon-news.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.LEAD_GENERATOR])
          },
          {
            to: { name: "ProviderListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_service_provider"),
            icon: "/static/icons/sidebar-icon-provider.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_SERVICE_PROVIDER
            ])
          },
          {
            to: { name: "AppointmentProductDashboardPage" },
            label: this.$t("feature.staff.access.subscription.subscription_product_appointment"),
            icon: "/static/icons/sidebar-icon-appointment.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_PRODUCT_APPOINTMENT
            ])
          },
          {
            to: { name: "AppointmentDashboardPage" },
            label: this.$t("feature.staff.access.subscription.subscription_appointment"),
            icon: "/static/icons/sidebar-icon-appointment.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_APPOINTMENT])
          },
          {
            to: { name: "ReceiptDashboardPage" },
            label: this.$t("feature.staff.access.subscription.subscription_receipt"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_RECEIPT])
          },
          {
            to: { name: "CouponListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_coupon"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_COUPON])
          },
          {
            to: { name: "RequestedPackageListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_requested_package"),
            icon: "",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_REQUESTED_PACKAGE
            ])
          },
          {
            to: { name: "SubscriberReportPage" },
            label: this.$t("feature.staff.access.subscription.subscription_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_REPORT])
          },
          {
            to: { name: "SubscriberAccountingReportPage" },
            label: this.$t("feature.staff.access.subscription.subscription_accounting_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_ACCOUNTING_REPORT
            ])
          },
          {
            to: { name: "RatingListPage" },
            label: this.$t("feature.staff.access.subscription.subscription_appointment_rating"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_APPOINTMENT_RATING
            ])
          },
          {
            to: { name: "RecurringDownloadReportPage" },
            label: this.$t("feature.staff.access.subscription.subscription_recurring_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.SUBSCRIPTION_RECURRING_REPORT,
            ])
          }
        ]
      };

      // TODO: change canView to Group Feature
      const groupMenu = {
        title: this.$t("feature.staff.access.group.group_name"),
        canView: this.canView([SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_PACKAGE_GROUP]),
        menu: [
          {
            to: { name: "PackageGroupMainPage" },
            label: this.$t("feature.staff.access.group.ruejai_club_package_group"),
            icon: "/static/icons/sidebar-icon-collection.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_PACKAGE_GROUP
            ])
          }
        ]
      };

      const sapMenu = {
        title: this.$t("feature.staff.access.sap.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.SAP_FI_REPORT,
          SIDE_NAV_BAR_FEATURE.SAP_MM_REPORT,
          SIDE_NAV_BAR_FEATURE.SAP_FI_ERROR_REPORT,
          SIDE_NAV_BAR_FEATURE.SAP_MM_ERROR_REPORT,
          SIDE_NAV_BAR_FEATURE.SAP_PO_VENDOR_REPORT,
          SIDE_NAV_BAR_FEATURE.SAP_FI_NOT_SENT_REPORT
        ]),
        menu: [
          {
            to: { name: "SapFiReport" },
            label: this.$t("feature.staff.access.sap.sap_fi_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SAP_FI_REPORT])
          },
          {
            to: { name: "SapMmReport" },
            label: this.$t("feature.staff.access.sap.sap_mm_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SAP_MM_REPORT])
          },
          {
            to: { name: "SapFiErrorReport" },
            label: this.$t("feature.staff.access.sap.sap_fi_error_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SAP_FI_ERROR_REPORT])
          },
          {
            to: { name: "SapMmErrorReport" },
            label: this.$t("feature.staff.access.sap.sap_mm_error_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SAP_MM_ERROR_REPORT])
          },
          {
            to: { name: "SapMmPoVenderReport" },
            label: this.$t("feature.staff.access.sap.sap_po_vendor_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SAP_PO_VENDOR_REPORT])
          },
          {
            to: { name: "SapFiNotSendReceipt" },
            label: this.$t("feature.staff.access.sap.sap_fi_not_sent_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SAP_FI_NOT_SENT_REPORT])
          }
        ]
      };

      const refinanceMenu = {
        title: this.$t("feature.staff.access.refinance.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.REFINANCE,
          SIDE_NAV_BAR_FEATURE.FINANCIAL_INSTITUTION_MANAGEMENT
        ]),
        menu: [
          {
            to: { name: "RefinanceListPage" },
            label: this.$t("feature.staff.access.refinance.refinance"),
            iconClass: "el-icon-document-copy",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.REFINANCE])
          },
          {
            to: { name: "FinancialInstitutionListPage" },
            label: this.$t("feature.staff.access.refinance.financial_institution"),
            iconClass: "el-icon-school",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.FINANCIAL_INSTITUTION_MANAGEMENT
            ])
          }
        ]
      };

      const sellAndRentMenu = {
        title: this.$t("feature.staff.access.sell_and_rent.group_name"),
        canView: this.canView([SIDE_NAV_BAR_FEATURE.SELL_AND_RENT]),
        menu: [
          {
            to: { name: "SellAndRentListPage" },
            label: this.$t("feature.staff.access.sell_and_rent.sell_and_rent"),
            icon: "/static/icons/sidebar-icon-collection.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.SELL_AND_RENT])
          }
        ]
      };

      const insuranceMenu = {
        title: this.$t("feature.staff.access.insurance.group_name"),
        canView: this.canView([SIDE_NAV_BAR_FEATURE.INSURANCE]),
        menu: [
          {
            to: { name: "InsuranceListPage" },
            label: this.$t("feature.staff.access.insurance.insurance"),
            iconClass: "el-icon-s-claim",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.INSURANCE])
          }
        ]
      };

      const monitoringMenu = {
        title: this.$t("feature.staff.access.monitoring.group_name"),
        canView: this.canView([SIDE_NAV_BAR_FEATURE.MONITORING]),
        menu: [
          {
            to: { name: "ThirdPartyNotificationListPage" },
            label: this.$t("feature.staff.access.monitoring.monitoring"),
            iconClass: "el-icon-bell",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.MONITORING])
          }
        ]
      };

      const ruejaiClubMenu = {
        title: this.$t("feature.staff.access.ruejai_club.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_BANNER,
          SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_TIER,
          SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_GROUP_CATEGORY,
          SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_CATEGORY,
          SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_VOUCHER_PACKAGE
        ]),
        menu: [
          {
            to: { name: "RuejaiClubBannerListPage" },
            label: this.$t("feature.staff.access.ruejai_club.group_name"),
            icon: "/static/icons/sidebar-icon-banner.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_BANNER])
          },
          {
            to: { name: "RuejaiClubTierListPage" },
            label: this.$t("feature.staff.access.ruejai_club.ruejai_club_tier"),
            icon: "/static/icons/sidebar-icon-collection.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_TIER])
          },
          {
            to: { name: "RuejaiClubGroupCategoryListPage" },
            label: this.$t("feature.staff.access.ruejai_club.ruejai_club_group_category"),
            icon: "/static/icons/sidebar-icon-service.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_GROUP_CATEGORY
            ])
          },
          {
            to: { name: "RuejaiClubCategoryListPage" },
            label: this.$t("feature.staff.access.ruejai_club.ruejai_club_category"),
            icon: "/static/icons/sidebar-icon-service.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_CATEGORY])
          },
          {
            to: { name: "RuejaiClubVoucherPackageListPage" },
            label: this.$t("feature.staff.access.ruejai_club.ruejai_club_voucher_package"),
            icon: "/static/icons/sidebar-icon-package.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.RUEJAI_CLUB_VOUCHER_PACKAGE
            ])
          }
        ]
      };

      const juristicMenu = {
        title: this.$t("feature.staff.access.juristic_system.group_name"),
        canView: this.canView([SIDE_NAV_BAR_FEATURE.JURISTIC_SYSTEM]),
        menu: [
          {
            to: { name: "JuristicFeatureListPage" },
            label: this.$t("feature.staff.access.juristic_system.juristic_system"),
            iconClass: "el-icon-setting",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.JURISTIC_SYSTEM])
          }
        ]
      };

      const homeAutomationMenu = {
        title: this.$t("feature.staff.access.home_automation.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.HOME_AUTOMATION_WEB,
          SIDE_NAV_BAR_FEATURE.HOME_AUTOMATION_APPOINTMENT
        ]),
        menu: [
          {
            to: { name: "HomeAutomationPage" },
            icon: "/static/icons/sidebar-icon-report.svg",
            label: this.$t("feature.staff.access.home_automation.home_automation_web"),
            canView: this.canView([SIDE_NAV_BAR_FEATURE.HOME_AUTOMATION_WEB])
          },
          {
            to: { name: "HomeAutomationAppointmentDashboardPage" },
            label: this.$t("feature.staff.access.home_automation.home_automation_appointment"),
            icon: "/static/icons/sidebar-icon-appointment.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.HOME_AUTOMATION_APPOINTMENT
            ])
          }
        ]
      };

      const morningCoinMenu = {
        title: this.$t("feature.staff.access.mnc.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.MNC_EARN_REPORT,
          SIDE_NAV_BAR_FEATURE.MNC_HOME_TRANSFER_REPORT,
          SIDE_NAV_BAR_FEATURE.MNC_WALLET_BALANCE_REPORT,
          SIDE_NAV_BAR_FEATURE.MNC_MANUAL_TRANSFER,
          SIDE_NAV_BAR_FEATURE.MNC_GIFT_BOX_REPORT,
        ]),
        menu: [
          {
            to: { name: "EarnCoinReportPage" },
            label: this.$t("feature.staff.access.mnc.mnc_earn_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.MNC_EARN_REPORT])
          },
          {
            to: { name: "TransferHomeReportPage" },
            label: this.$t("feature.staff.access.mnc.mnc_home_transfer_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.MNC_HOME_TRANSFER_REPORT
            ])
          },
          {
            to: { name: "WalletBalanceReportPage" },
            label: this.$t("feature.staff.access.mnc.mnc_wallet_balance_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.MNC_WALLET_BALANCE_REPORT
            ])
          },
          {
            to: { name: "WalletToEarnUserPage" },
            label: this.$t("feature.staff.access.mnc.mnc_manual_transfer"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.MNC_MANUAL_TRANSFER])
          },
          {
            to: { name: "GiftBoxReportPage" },
            label: this.$t("feature.staff.access.mnc.mnc_gift_box_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.MNC_GIFT_BOX_REPORT
            ])
          }
        ]
      };

      const conferenceMenu = {
        title: this.$t("feature.staff.access.conference.group_name"),
        canView: this.canView([SIDE_NAV_BAR_FEATURE.CONFERENCE]),
        menu: [
          {
            to: { name: "ConferenceList" },
            label: this.$t("feature.staff.access.conference.conference"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([SIDE_NAV_BAR_FEATURE.CONFERENCE])
          }
        ]
      };

      const redeemedMNCMenu = {
        title: this.$t("feature.staff.access.reward_store.group_name"),
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.REWARD_STORE_REDEEM_REPORT,
          SIDE_NAV_BAR_FEATURE.REWARD_STORE_HOME_DISCOUNT_REPORT
        ]),
        menu: [
          {
            to: { name: "RedeemedVoucherReportPage" },
            label: this.$t("feature.staff.access.reward_store.reward_store_redeem_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.REWARD_STORE_REDEEM_REPORT
            ])
          },
          {
            to: { name: "HomeDiscountVoucherReportPage" },
            label: this.$t("feature.staff.access.reward_store.reward_store_home_discount_report"),
            icon: "/static/icons/sidebar-icon-report.svg",
            canView: this.canView([
              SIDE_NAV_BAR_FEATURE.REWARD_STORE_HOME_DISCOUNT_REPORT
            ])
          }
        ]
      };

      // Non-SC Menu
      const nonScMenu = {
        title: 'Non-SC Management',
        canView: this.canView([
          SIDE_NAV_BAR_FEATURE.NONSC_MGMT
        ]),
        menu: [
          {
            to: {
              name: "nonsc-project"
            },
            iconClass: "el-icon-office-building",
            label: this.$t("feature.staff.access.nonsc.project"),
          },
          {
            to: {
              name: "nonsc-home"
            },
            iconClass: "el-icon-s-home",
            label: this.$t("feature.staff.access.nonsc.home"),
          },
          {
            to: {
              name: "nonsc-user"
            },
            iconClass: "el-icon-s-custom",
            label: this.$t("feature.staff.access.nonsc.user"),
          },
        ]
      }

      return [
        articleMenu,
        managementMenu,
        nonScMenu,
        subscriptionMenu,
        groupMenu,
        homeAutomationMenu,
        EvMenu,
        refinanceMenu,
        sellAndRentMenu,
        insuranceMenu,
        monitoringMenu,
        ruejaiClubMenu,
        juristicMenu,
        sapMenu,
        redeemedMNCMenu,
        morningCoinMenu,
        conferenceMenu
      ];
    },
    permissionFeatureById() {
      if (!this.permission) {
        return {};
      }

      const { features = [] } = this.permission;

      return features.reduce((all, feature) => {
        all[feature.featureId] = feature;

        return all;
      }, {});
    },
    permissionFeatureByName() {
      if (!this.permission) {
        return {};
      }

      const { features = [] } = this.permission;

      return features.reduce((all, feature) => {
        all[feature.featureName] = feature;

        return all;
      }, {});
    },
    envName() {
      const name = process.env.DEPLOY_ENV
        ? process.env.DEPLOY_ENV
        : process.env.NODE_ENV;

      return name;
    },
    isPermissionManager() {
      return this.permission.role === permissionRole.LMM;
    },
    isPermissionAgent() {
      return this.permission.role === permissionRole.LMA;
    },
    isPermissionCallCenter() {
      return this.permission.role === permissionRole.LMC;
    }
  },
  mounted() {
    this.loadGreeting();
    this.loadContactBadge();
  },
  watch: {
    $route() {
      // this.loadGreeting();
    }
  },
  methods: {
    articleRoute(type) {
      const name = !this.$isCallCenter ? "ArticleList" : "ArticleListStatus";
      const params = !this.$isCallCenter
        ? { articleType: type }
        : { articleType: type, articleStatus: "published" };
      return { name, params };
    },
    canView(permission = []) {
      if (!Array.isArray(permission)) {
        permission = [permission];
      }

      return permission.some(
        feature =>
          feature in this.permissionFeatureById ||
          feature in this.permissionFeatureByName
      );
    },
    canViewCheckRole(role) {
      return role.includes(this.permission.roleName);
    },
    canViewCheckRoleByCode(role) {
      return role.includes(this.permission.role);
    },
    canNotViewCheckRoleByCode(role) {
      return !role.includes(this.permission.role);
    },
    showSidebar(action) {
      this.$store.state.sideBar = action;
    },
    async logout(action) {
      if (action) {
        // Get Microsoft session
        const msSession = localStorage.getItem("microsoftSessionId");

        // If Microsoft session exists
        if (msSession) {
          await backendAdminClient.auth.microsoft.logout()
        } else {
          if (this.$messaging) {
            try {
              const currentToken = await this.$messaging.getToken();

              baanRueJaiClient.setAuthorizationToken();
              await this.$messaging.deleteToken(currentToken);
            } catch (error) {
              console.debug(error);
            }
          }

          localStorage.removeItem("adminName");
          localStorage.removeItem("adminRole");
          localStorage.removeItem("adminRolePermission");
          localStorage.removeItem("adminProjects");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");

          unsetCookie(Auth.AccessToken);
          unsetCookie(Auth.RefreshToken);

          this.$router.push({ name: "Login" });
        }
      } else {
        this.showLogout = false;
      }
    },
    loadGreeting() {
      if (this.canView(8)) {
        return axios
          .get(`${process.env.HOST}/admin/greeting/members`, {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
            }
          })
          .then(res => {
            const greetings = res.data || [];
            this.greetings = greetings;
            return greetings;
          })
          .catch(e => {
            this.greetings = [];
            throw e;
          });
      }
    },
    loadContactBadge() {
      if (this.canView(8)) {
        return axios
          .get(`${process.env.HOST}/admin/conversations/projects/badges`, {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
            }
          })
          .then(res => {
            const contactBadge = res.data || [];
            let badgeCount = 0;
            contactBadge.forEach(item => {
              badgeCount += item.unread;
            });
            this.contactBadge = badgeCount;
            return contactBadge;
          })
          .catch(e => {
            this.contactBadge = 0;
            throw e;
          });
      }
    },
    handleOpenNewTab(route) {
      if (event.ctrlKey || event.metaKey) {
        const routeData = this.$router.resolve(route);

        window.open(routeData.href, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding-top: 20px;
  padding-left: 15px;
  border-bottom: solid 1px #f4f4f2;
  
  .logo  {
    color           : black;
    font-weight     : bold;
    letter-spacing  : 0;
    margin-bottom   : .75rem;
  }

  .media {
    padding     : .5rem 0;
    padding-top : 0;
  }
}

.env-name {
  color           : $primary-color;
  font-family     : monospace;
  margin          : 0;
  text-transform  : uppercase;
}

.sidebar-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;

  ul {
    padding: 0;
    margin: 0;

    li {
      line-height: 0;
    }
  }

  li {
    label {
      font-size: 1rem;
      font-weight: bold;
      color: $black;
      display: block;
      padding: 16px 0 0 16px;
      margin-bottom: 8px;
    }
  }
  
  .sidebar-detail {
    color         : #222;
    padding-left  : 2px ;

    &:hover {
      background-color: #f9f9f9;
      text-decoration: none;
      color: #222;
    }
    &.active,
    &:focus {
      background-color: #f9f9f9;
      text-decoration: none;
      color: #222;
      font-weight: bold;
    }

    &.notification {
      position: relative;
      &::after {
        position: absolute;
        top: 50%;
        right: 15px;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        content: "";
        background: #fe676f;
        display: block;
      }
    }

    img {
      max-width: 1.25rem;
    }

    .sidebar-item {
      display       : flex;
      align-items   : center;
      gap           : .65rem;
      padding       : .75rem 1rem;

      i {
        font-size: 1.25rem;
      }

      .item-name {
        font-size: .9rem;
      }
    }

    &.active {
      border-left: 4px solid $orange;

      .sidebar-item {
        padding-left: calc(1rem - 4px);
      }

      .item-name {
        font-weight : bold;
      }

      i, .item-name {
        color: $orange;
      }
    }
  }
}
.version {
  color: #8c8786;
  bottom: 0;
  padding: 5px;
  position: fixed;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/layout/SideNavBar.vue